export const articlesRiskExtra = [
  {
    slug: 'beginner-risks',
    category: 'การบริหารความเสี่ยง',
    categorySlug: 'risk-management',
    title: 'ความเสี่ยงที่มือใหม่ควรรู้ก่อนเริ่มเทรด Forex',
    description:
      'รวมความเสี่ยงที่มือใหม่มักเจอตั้งแต่ยังไม่ทันตั้งตัว ทั้งความเสี่ยงตลาด ขนาดสถานะ Leverage สภาพคล่อง และพฤติกรรมของตัวเอง',
    readingTime: '7 นาที',
    updatedDate: '2026-10-18',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20beginner%20risk%20checklist%20concept%20teal%20rounded%20panels%20with%20warm%20orange%20warning%20marks%20on%20light%20clean%20background%20editorial%20flat%20fintech%20design%20no%20text%20no%20people&width=1200&height=675&seq=art-beginner-risks-01&orientation=landscape',
    tags: ['ความเสี่ยง', 'มือใหม่', 'พื้นฐาน'],
    intro: [
      'มือใหม่มักเริ่มจากการหาจุดเข้าและวิธีทำกำไร แต่ความเสี่ยงที่ทำให้พอร์ตเสียหายกลับมาจากเรื่องที่ไม่ได้อยู่ในกราฟ',
      'บทความนี้สรุปความเสี่ยงหลักที่ควรรู้ก่อนเปิดออเดอร์แรก เพื่อให้คุณเริ่มต้นด้วยกรอบความคิดที่ถูกต้อง',
    ],
    sections: [
      {
        id: 'market',
        heading: 'ความเสี่ยงจากตลาดเอง',
        paragraphs: [
          'ราคา Forex เปลี่ยนตลอดเวลาจากข่าวเศรษฐกิจ นโยบายดอกเบี้ย และกระแสเงินลงทุน ไม่มีใครวิเคราะห์แล้วถูกทุกครั้ง',
          'เพราะฉะนั้นทุกออเดอร์ควรมีจุดที่ยอมรับว่าคิดผิด และกำหนดความเสียหายสูงสุดไว้ล่วงหน้าเสมอ',
        ],
        bullets: [
          'ราคาอาจสวนทางกับบทวิเคราะห์ได้ตลอด',
          'ข่าวสำคัญทำให้ราคากระโดดและ Spread กว้างขึ้น',
          'ทุกแผนต้องมีจุดที่ยอมรับว่าคิดผิด',
        ],
        steps: [],
      },
      {
        id: 'size',
        heading: 'ความเสี่ยงจากขนาดสถานะและ Leverage',
        paragraphs: [
          'Leverage ทำให้เปิดสถานะใหญ่ได้ด้วยเงินประกันน้อย แต่ความเสี่ยงจริงขึ้นอยู่กับขนาดสถานะเทียบกับเงินทุน',
          'มือใหม่ที่เลือกขนาดจากความมั่นใจมักพบว่าราคาแกว่งเพียงเล็กน้อยก็กินเงินทุนไปหลายเปอร์เซ็นต์',
        ],
        bullets: [
          'ขนาดสถานะคือตัวกำหนดผลกระทบต่อพอร์ต',
          'Leverage สูงไม่ได้ทำให้ขาดทุนเสมอ แต่ทำให้พลาดง่ายขึ้น',
          'คำนวณขนาดจากความเสี่ยง ไม่ใช่จากความมั่นใจ',
        ],
        steps: [],
      },
      {
        id: 'behavior',
        heading: 'ความเสี่ยงจากพฤติกรรมของเรา',
        paragraphs: [
          'การอยากเอาคืนหลังขาดทุน การเลื่อน Stop Loss และการเทรดถี่เกินแผน เป็นสาเหตุที่พบบ่อยที่สุดของความเสียหายก้อนใหญ่',
          'เขียนกติกาส่วนตัวให้ชัดและทบทวนผลการเทรดอย่างสม่ำเสมอ จะช่วยลดโอกาสตัดสินใจตามอารมณ์',
        ],
        bullets: [
          'ไม่เลื่อน Stop Loss ให้ห่างออกไป',
          'กำหนดจำนวนออเดอร์สูงสุดต่อวัน',
          'บันทึกเหตุผลก่อนและหลังทุกออเดอร์',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'มือใหม่ควรเริ่มด้วยเงินเท่าไร',
        a: 'ควรเป็นเงินที่ยอมเสียได้ทั้งหมดโดยไม่กระทบชีวิตประจำวัน เพราะช่วงแรกคือการเรียนรู้ ไม่ใช่การทำรายได้',
        a2: 'ตัวเลขที่ใช้ได้จริงคือ 500-1,000 ดอลลาร์สำหรับบัญชีจริงบัญชีแรก ซึ่งเปิดไม้ 0.01 Lot ได้ราว 5-10 ไม้พร้อมกันโดยใช้ความเสี่ยง 1% ต่อไม้ ถ้าน้อยกว่านั้น ข้อจำกัดเรื่องขนาด Lot จะทำให้บริหารความเสี่ยงแทบทำไม่ได้',
      },
      {
        q: 'ความเสี่ยงข้อไหนอันตรายที่สุด',
        a: 'ความเสี่ยงจากพฤติกรรมของตัวเองมักอันตรายที่สุด เพราะมันทำให้ความเสี่ยงอื่น ๆ ถูกขยายเกินแผนไปโดยไม่รู้ตัว',
        a2: 'เพราะความเสี่ยงจากตลาดอย่าง Spread หรือข่าว เป็นสิ่งที่คาดการณ์และจำกัดได้ด้วยขนาดสถานะ แต่การเพิ่ม Lot หลังขาดทุนหรือเลื่อน Stop Loss ออกไป คือการขยายความเสี่ยงที่แผนเดิมไม่ได้รองรับ ผลคือขาดทุนไม้เดียวอาจกินกำไร 10 ไม้',
      },
    ],
    related: ['risk-management-basics', 'high-leverage-risk', 'risk-per-trade'],
  },
  {
    slug: 'risk-per-trade',
    category: 'การบริหารความเสี่ยง',
    categorySlug: 'risk-management',
    title: 'ความเสี่ยงต่อการเทรดหนึ่งครั้งคืออะไร และควรคิดอย่างไร',
    description:
      'อธิบายความหมายของ Risk per Trade วิธีคิดเป็นเปอร์เซ็นต์ของพอร์ต และเหตุใดความเสี่ยงคงที่จึงช่วยให้รับมือการขาดทุนต่อเนื่องได้',
    readingTime: '6 นาที',
    updatedDate: '2026-10-17',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20risk%20per%20trade%20concept%20teal%20account%20bar%20with%20a%20small%20warm%20orange%20segment%20highlighted%20on%20light%20clean%20background%20editorial%20flat%20fintech%20design%20no%20text%20no%20people&width=1200&height=675&seq=art-risk-per-trade-01&orientation=landscape',
    tags: ['Risk per Trade', 'ความเสี่ยง', 'Position Sizing'],
    intro: [
      'ความเสี่ยงต่อการเทรดหนึ่งครั้งคือจำนวนเงินสูงสุดที่ยอมให้ออเดอร์นั้นพาไปได้ เป็นตัวเลขที่เรากำหนดเองได้ก่อนตลาดจะตอบ',
      'เมื่อกำหนดค่านี้คงที่ การขาดทุนต่อเนื่องจะกลายเป็นเรื่องที่คาดการณ์และฟื้นตัวได้ ไม่ใช่เรื่องที่ทำลายพอร์ต',
    ],
    sections: [
      {
        id: 'meaning',
        heading: 'Risk per Trade คืออะไร',
        paragraphs: [
          'Risk per Trade คือส่วนต่างระหว่างราคาเข้าที่วางแผนไว้กับจุด Stop Loss เมื่อแปลงเป็นเงินแล้วจะได้เพดานขาดทุนของออเดอร์นั้น',
          'โดยทั่วไปนิยมคิดเป็นเปอร์เซ็นต์ของเงินทุน เพื่อให้ความหมายคงเดิมเมื่อพอร์ตโตขึ้นหรือลดลง',
        ],
        bullets: [
          'เป็นเพดานขาดทุน ไม่ใช่จำนวนเงินที่ใช้เปิดออเดอร์',
          'คิดเป็นเปอร์เซ็นต์เพื่อปรับตามขนาดพอร์ต',
          'ต้องสอดคล้องกับระยะ Stop Loss จริง',
        ],
        steps: [],
      },
      {
        id: 'formula',
        heading: 'คำนวณอย่างไร',
        paragraphs: [
          'เริ่มจากเงินทุนคูณเปอร์เซ็นต์ความเสี่ยงที่กำหนด จะได้จำนวนเงินที่ยอมเสีย จากนั้นนำไปหารด้วยระยะ Stop Loss และมูลค่าต่อจุดเพื่อหาขนาดสถานะ',
          'ถ้าระยะ Stop Loss กว้างขึ้น จำนวนเงินเดิมจะรองรับขนาดสถานะที่เล็กลงเสมอ นี่คือเหตุผลที่ขนาดต้องคำนวณใหม่ทุกออเดอร์',
        ],
        bullets: [
          'ความเสี่ยงเป็นเงิน = เงินทุน × เปอร์เซ็นต์ความเสี่ยง',
          'ขนาดสถานะขึ้นอยู่กับระยะ Stop Loss',
          'หลีกเลี่ยงการใช้ขนาดสถานะคงที่ทุกออเดอร์',
        ],
        steps: [],
      },
      {
        id: 'series',
        heading: 'ทำไมต้องคงที่',
        paragraphs: [
          'ถ้าแต่ละออเดอร์เสี่ยง 1% ของพอร์ต การขาดทุนสิบครั้งติดกันจะลดพอร์ตประมาณ 10% ซึ่งยังฟื้นตัวได้ด้วยแผนเดิม',
          'แต่ถ้าเพิ่มความเสี่ยงเป็น 5% ต่อออเดอร์ การขาดทุนต่อเนื่องเพียงไม่กี่ครั้งก็อาจทำให้พอร์ตเสียหายเกินกว่าจะกลับมา',
        ],
        bullets: [
          'ความเสี่ยงคงที่ทำให้ผลลัพธ์คาดการณ์ได้',
          'ลดโอกาสพอร์ตเสียหายแบบกู้คืนยาก',
          'ไม่เพิ่มความเสี่ยงเพราะอยากเอาคืน',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'ความเสี่ยงต่อออเดอร์ควรเป็นกี่เปอร์เซ็นต์',
        a: 'ไม่มีตัวเลขที่เหมาะกับทุกคน มือใหม่มักเริ่มจากสัดส่วนเล็กของพอร์ตเพื่อให้ทนต่อการขาดทุนต่อเนื่องได้หลายครั้ง',
        a2: 'ค่าที่นิยมใช้คือ 1% ต่อออเดอร์ ซึ่งแปลว่าขาดทุนติดกัน 10 ครั้งยังเหลือทุน 90% และฟื้นกลับได้ด้วยกำไรราว 11% ส่วน 5% ต่อไม้จะเหลือทุนเพียง 60% หลังขาดทุน 10 ครั้ง และต้องทำกำไร 66% เพื่อกลับมาเท่าทุน',
      },
      {
        q: 'เปลี่ยนเปอร์เซ็นต์ความเสี่ยงได้ไหม',
        a: 'ทำได้ แต่ควรเป็นการตัดสินใจตามแผนและข้อมูล ไม่ใช่เปลี่ยนทันทีหลังขาดทุนเพื่อให้กลับมาเท่าทุนเร็วขึ้น',
        a2: 'หลักที่ใช้ได้คือ ปรับตามผลของหลายสิบไม้ ไม่ใช่ไม้เดียว ถ้าพบว่าขาดทุนติดกัน 8 ครั้งแล้วยังไหว แสดงว่า 1% เหมาะสม แต่ถ้าเริ่มนอนไม่หลับที่ 3 ครั้ง แปลว่าเพดานจริงของคุณต่ำกว่า 1% และควรลดลงก่อน',
      },
    ],
    related: ['position-sizing', 'how-to-calculate-lot', 'consecutive-losses'],
  },
  {
    slug: 'take-profit',
    category: 'การบริหารความเสี่ยง',
    categorySlug: 'risk-management',
    title: 'Take Profit คืออะไร และควรกำหนดจากอะไร',
    description:
      'ทำความเข้าใจ Take Profit จุดทำกำไรตามแผน วิธีอ้างอิงจากโครงสร้างราคา และเหตุผลที่การตั้งไกลเกินจริงไม่ได้ทำให้กำไรมากขึ้น',
    readingTime: '6 นาที',
    updatedDate: '2026-10-16',
    level: 'เริ่มเทรด',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20take%20profit%20concept%20teal%20price%20path%20rising%20to%20a%20warm%20orange%20target%20marker%20on%20light%20clean%20background%20editorial%20flat%20fintech%20design%20no%20text%20no%20people&width=1200&height=675&seq=art-take-profit-01&orientation=landscape',
    tags: ['Take Profit', 'Stop Loss', 'ความเสี่ยง'],
    intro: [
      'Take Profit คือจุดที่แผนกำหนดว่าจะปิดออเดอร์เพื่อรับกำไร ช่วยให้ผลลัพธ์ไม่ขึ้นอยู่กับการตัดสินใจด้วยความโลภในจังหวะนั้น',
      'มันทำงานคู่กับ Stop Loss เสมอ เพราะทั้งสองจุดร่วมกันกำหนด Risk/Reward Ratio ของออเดอร์',
    ],
    sections: [
      {
        id: 'what',
        heading: 'Take Profit ทำหน้าที่อะไร',
        paragraphs: [
          'Take Profit คือคำสั่งปิดสถานะอัตโนมัติเมื่อราคาไปถึงระดับที่กำหนด เป็นการล็อกกำไรตามแผนโดยไม่ต้องเฝ้าหน้าจอ',
          'การมีจุดนี้ชัดเจนช่วยลดการตัดสินใจซ้ำซ้อน และทำให้เราวัดผลได้ว่าออเดอร์นั้นเป็นไปตามแผนหรือไม่',
        ],
        bullets: [
          'ปิดออเดอร์อัตโนมัติเมื่อถึงเป้าหมาย',
          'ลดการตัดสินใจจากอารมณ์ระหว่างทาง',
          'ต้องสอดคล้องกับ Stop Loss และแผนเทรด',
        ],
        steps: [],
      },
      {
        id: 'how-to-set',
        heading: 'กำหนดจากอะไร',
        paragraphs: [
          'จุดทำกำไรที่ดีมักอ้างอิงโซนราคาที่มีนัยสำคัญ เช่น แนวต้านถัดไปหรือขอบเขตของกรอบราคา ไม่ใช่การเดาตัวเลขกลม ๆ',
          'เมื่อกำหนดจุดได้แล้ว ให้ตรวจ Risk/Reward Ratio ว่าคุ้มกับความเสี่ยงหรือไม่ ถ้าไม่คุ้มก็ควรเลือกไม่เทรดออเดอร์นั้น',
        ],
        bullets: [
          'อ้างอิงแนวต้านหรือโซนราคาที่มีนัยสำคัญ',
          'ตรวจ Risk/Reward ก่อนกดออเดอร์',
          'ไม่ตั้งไกลเกินจริงจนแผนขาดเหตุผลรองรับ',
        ],
        steps: [],
      },
      {
        id: 'limits',
        heading: 'ข้อจำกัดที่ควรเข้าใจ',
        paragraphs: [
          'Take Profit ไม่ได้รับประกันว่าราคาจะไปถึง และไม่ได้รับประกันว่าจะได้ราคาตามที่ตั้งเมื่อตลาดกระโดดข้ามระดับ',
          'เช่นเดียวกับ Stop Loss ควรถือว่าจุดนี้เป็นแผน ไม่ใช่คำสัญญาจากตลาด',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Take Profit ต้องไกลกว่า Stop Loss เสมอไหม',
        a: 'ไม่จำเป็นเสมอไป แต่ถ้าระยะกำไรใกล้กว่าความเสี่ยงมาก อัตราการชนะที่ต้องใช้เพื่อให้ผลลัพธ์เป็นบวกจะสูงขึ้น',
        a2: 'ตัวเลขที่ควรจำคือ ถ้า TP 20 Pip กับ SL 40 Pip ต้องชนะเกิน 67% จึงจะเสมอตัว ส่วน TP 40 กับ SL 20 ชนะแค่ 34% ก็พอ นี่คือเหตุผลที่คนส่วนใหญ่เลือก TP ไกลกว่า SL อย่างน้อย 1.5 เท่า',
      },
      {
        q: 'ตั้ง Take Profit แล้วยังปิดเองก่อนได้ไหม',
        a: 'ทำได้ตามแผนที่วางไว้ แต่ควรมีเหตุผลจากข้อมูล ไม่ใช่เพราะกลัวกำไรหายหรืออยากได้เพิ่ม',
        a2: 'ถ้าปิดก่อนถึง TP บ่อยครั้ง ควรบันทึกว่าปิดเพราะอะไร แล้วเทียบผลกับไม้ที่ปล่อยถึง TP ในอีก 20-30 ไม้ ถ้าพบว่าปิดเองได้ผลแย่กว่า ให้เปลี่ยนวิธีเป็นปิดบางส่วนที่ 50% ของระยะทางแทนการปิดทั้งหมด',
      },
    ],
    related: ['stop-loss-take-profit', 'risk-reward-ratio', 'stop-loss-not-guaranteed'],
  },
  {
    slug: 'stop-loss-not-guaranteed',
    category: 'การบริหารความเสี่ยง',
    categorySlug: 'risk-management',
    title: 'ทำไมการตั้ง Stop Loss จึงไม่รับประกันราคาปิดตามที่กำหนด',
    description:
      'Stop Loss จำกัดความเสียหายตามแผน แต่ราคาที่ปิดจริงอาจต่างออกไปเมื่อตลาดกระโดดข้ามระดับหรือสภาพคล่องต่ำ',
    readingTime: '6 นาที',
    updatedDate: '2026-10-15',
    level: 'เริ่มเทรด',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20stop%20loss%20gap%20concept%20teal%20price%20line%20jumping%20over%20a%20warm%20orange%20dashed%20level%20on%20light%20clean%20background%20editorial%20flat%20fintech%20design%20no%20text%20no%20people&width=1200&height=675&seq=art-stop-loss-limit-01&orientation=landscape',
    tags: ['Stop Loss', 'Slippage', 'ความเสี่ยง'],
    intro: [
      'หลายคนเข้าใจว่าเมื่อตั้ง Stop Loss ไว้แล้ว ขาดทุนจะไม่เกินระดับนั้นเสมอ แต่ในตลาดจริงมีบางสถานการณ์ที่ราคาข้ามระดับนั้นไปก่อนคำสั่งจะถูกจับคู่',
      'การเข้าใจข้อจำกัดนี้ทำให้เราวางแผนความเสี่ยงได้สมจริงขึ้น และไม่ประเมินความเสี่ยงต่ำเกินไป',
    ],
    sections: [
      {
        id: 'how-it-works',
        heading: 'Stop Loss ทำงานอย่างไร',
        paragraphs: [
          'Stop Loss คือคำสั่งที่ส่งเข้าตลาดเมื่อราคาแตะระดับที่กำหนด จากนั้นคำสั่งจะถูกจับคู่ที่ราคาที่มีอยู่จริงในขณะนั้น',
          'ถ้ามีคำสั่งฝั่งตรงข้ามที่ระดับนั้นพอดี ราคาที่ได้จะใกล้เคียงกับที่ตั้งไว้ แต่ถ้าไม่มี ราคาที่ได้อาจต่างออกไป',
        ],
        bullets: [
          'Stop Loss เป็นคำสั่ง ไม่ใช่การรับประกันราคา',
          'ราคาที่ได้จริงขึ้นอยู่กับคำสั่งที่รออยู่ในตลาด',
          'สภาพคล่องคือปัจจัยสำคัญในจังหวะนั้น',
        ],
        steps: [],
      },
      {
        id: 'gap',
        heading: 'เมื่อตลาดกระโดดข้ามระดับ',
        paragraphs: [
          'ในช่วงข่าวสำคัญหรือช่วงเปิดตลาด ราคาอาจกระโดดข้ามระดับ Stop Loss ไปเลยโดยไม่มีการซื้อขายที่ระดับนั้น ทำให้ออเดอร์ถูกปิดที่ราคาถัดไป',
          'เหตุการณ์นี้ทำให้ขาดทุนมากกว่าที่คำนวณไว้ได้ จึงควรหลีกเลี่ยงการถือออเดอร์ผ่านข่าวที่ไม่สามารถประเมินผลได้',
        ],
        bullets: [
          'Gap ทำให้ราคาข้ามระดับโดยไม่มีการซื้อขายตรงจุดนั้น',
          'ขาดทุนจริงอาจเกินเพดานที่คำนวณไว้',
          'หลีกเลี่ยงการถือออเดอร์ผ่านข่าวสำคัญ',
        ],
        steps: [],
      },
      {
        id: 'plan',
        heading: 'วางแผนอย่างไรให้สมจริง',
        paragraphs: [
          'กำหนดความเสี่ยงต่อออเดอร์ให้มีช่องว่างเผื่อความคลาดเคลื่อน และหลีกเลี่ยงการใช้ความเสี่ยงเต็มเพดานทุกครั้ง',
          'ถ้าเทรดในช่วงที่สภาพคล่องต่ำ ควรลดขนาดสถานะลงหรือหลีกเลี่ยงช่วงเวลานั้นไปเลย',
        ],
        bullets: [
          'เผื่อความคลาดเคลื่อนไว้ในแผนความเสี่ยง',
          'ลดขนาดสถานะเมื่อสภาพคล่องต่ำ',
          'หลีกเลี่ยงช่วงข่าวที่ไม่สามารถประเมินได้',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Stop Loss ยังจำเป็นอยู่ไหมถ้าไม่ได้การันตีราคา',
        a: 'จำเป็น เพราะยังช่วยจำกัดความเสียหายในสถานการณ์ปกติ และเป็นจุดที่บอกว่าแผนผิด ที่สำคัญคือต้องเข้าใจว่ามันมีข้อจำกัด',
        a2: 'ข้อจำกัดที่ต้องเข้าใจคือ Stop Loss เป็นคำสั่งที่ราคาต้องมีคู่สัญญาตรงนั้นจึงจะจับได้ ในช่วงข่าวแรงหรือตลาดเปิด Gap ราคาอาจกระโดดข้ามระดับที่ตั้งไว้ และคุณจะขาดทุนมากกว่าที่คำนวณ สิ่งที่ช่วยได้คือลดขนาดสถานะและหลีกเลี่ยงการถือข้ามข่าวใหญ่',
      },
      {
        q: 'ทำอย่างไรไม่ให้ขาดทุนเกิน Stop Loss',
        a: 'ควบคุมไม่ได้ทั้งหมด แต่ลดโอกาสได้ด้วยการลดขนาดสถานะ หลีกเลี่ยงช่วงข่าว และไม่ใช้ความเสี่ยงเต็มเพดานในทุกออเดอร์',
        a2: 'สามมาตรการที่ได้ผลจริงคือ ใช้ความเสี่ยงไม่เกิน 0.5-1% ต่อไม้ ไม่ถือออเดอร์ข้ามข่าว Non-Farm Payrolls หรือการประกาศดอกเบี้ย และลด Lot ลงครึ่งหนึ่งในวันที่ Spread กว้างกว่า 2 เท่าของปกติ เพราะทั้งสามอย่างนี้ลดผลของ Slippage ได้ตรงจุด',
      },
    ],
    related: ['stop-loss-take-profit', 'what-is-slippage', 'risk-per-trade'],
  },
  {
    slug: 'consecutive-losses',
    category: 'การบริหารความเสี่ยง',
    categorySlug: 'risk-management',
    title: 'การขาดทุนต่อเนื่องส่งผลต่อเงินทุนอย่างไร',
    description:
      'การขาดทุนติดกันหลายครั้งไม่ใช่เรื่องผิดปกติ บทความนี้อธิบายผลต่อเงินทุนและวิธีตั้งเพดานความเสี่ยงให้ยังฟื้นตัวได้',
    readingTime: '7 นาที',
    updatedDate: '2026-10-14',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20consecutive%20losses%20concept%20teal%20descending%20stepped%20bars%20with%20warm%20orange%20floor%20line%20on%20light%20clean%20background%20editorial%20flat%20fintech%20design%20no%20text%20no%20people&width=1200&height=675&seq=art-consecutive-losses-01&orientation=landscape',
    tags: ['Drawdown', 'ความเสี่ยง', 'วินัย'],
    intro: [
      'แม้ระบบเทรดที่ดีก็ยังมีช่วงที่ขาดทุนติดกันหลายครั้ง สิ่งที่กำหนดว่าพอร์ตจะรอดหรือไม่คือขนาดความเสี่ยงต่อออเดอร์',
      'บทความนี้ชวนดูผลของการขาดทุนต่อเนื่องแบบง่าย ๆ เพื่อให้เห็นว่าทำไมการจำกัดความเสี่ยงจึงสำคัญกว่าการพยายามชนะทุกออเดอร์',
    ],
    sections: [
      {
        id: 'math',
        heading: 'ผลของการขาดทุนต่อเนื่อง',
        paragraphs: [
          'ถ้าเสี่ยง 1% ต่อออเดอร์และขาดทุนสิบครั้งติดกัน พอร์ตจะลดลงประมาณ 10% ซึ่งยังอยู่ในระดับที่แผนเดิมฟื้นกลับได้',
          'แต่ถ้าเสี่ยง 5% ต่อออเดอร์ การขาดทุนสิบครั้งติดกันจะทำให้พอร์ตเหลือไม่ถึงครึ่ง และต้องใช้กำไรที่สูงมากเพื่อกลับมาเท่าทุน',
        ],
        bullets: [
          'ความเสี่ยงต่อออเดอร์ถูกคูณด้วยจำนวนครั้งที่ขาดทุน',
          'ยิ่งเสี่ยงมาก จำนวนครั้งที่ทนได้ยิ่งน้อยลง',
          'พอร์ตที่ลดลึกต้องใช้กำไรเปอร์เซ็นต์ที่สูงขึ้นมาก',
        ],
        steps: [],
      },
      {
        id: 'normal',
        heading: 'ขาดทุนต่อเนื่องเป็นเรื่องปกติ',
        paragraphs: [
          'ถ้าอัตราการชนะอยู่ที่ 50% การขาดทุนติดกันสี่ถึงห้าครั้งย่อมเกิดขึ้นได้ในระยะยาว ไม่ได้แปลว่าระบบพัง',
          'ปัญหาคือเทรดเดอร์มักตีความว่าต้องเปลี่ยนระบบทันที หรือเพิ่มความเสี่ยงเพื่อชดเชย ซึ่งทำให้แผนเสียมากกว่าที่ระบบเสีย',
        ],
        bullets: [
          'อย่าตัดสินระบบจากผลแค่ไม่กี่ออเดอร์',
          'แยกความผิดปกติของระบบออกจากความผันผวนปกติ',
          'อย่าเพิ่มความเสี่ยงเพื่อชดเชย',
        ],
        steps: [],
      },
      {
        id: 'limit',
        heading: 'ตั้งเพดานรับมือล่วงหน้า',
        paragraphs: [
          'กำหนดจำนวนครั้งที่ยอมให้ขาดทุนต่อวันหรือต่อสัปดาห์ และเพดาน Drawdown ที่จะหยุดทบทวน เมื่อถึงจุดนั้นให้หยุดเทรดก่อน',
          'การมีเพดานที่ชัดเจนทำให้การตัดสินใจไม่ต้องเกิดในจังหวะที่อารมณ์แย่ที่สุด',
        ],
        bullets: [
          'กำหนดเพดานขาดทุนรายวัน',
          'หยุดทบทวนเมื่อพอร์ตลดถึงระดับที่กำหนด',
          'กลับมาเทรดเมื่อมีข้อมูลและแผนที่ชัดเจน',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'ขาดทุนติดกันกี่ครั้งจึงควรหยุด',
        a: 'ขึ้นอยู่กับแผนของแต่ละคน แต่การกำหนดจำนวนครั้งหรือเพดานขาดทุนล่วงหน้าจะช่วยให้ตัดสินใจได้ง่ายและเป็นกลางกว่า',
        a2: 'ตัวเลขที่ใช้กันทั่วไปคือหยุดเมื่อขาดทุน 3 ครั้งติด หรือเมื่อขาดทุนรวมแตะ 6% ของพอร์ตในหนึ่งวัน แล้วกลับมาทบทวนตอนปิดตลาด เกณฑ์แบบนี้ทำให้การหยุดเป็นการตัดสินใจล่วงหน้า ไม่ใช่การยอมแพ้กลางคัน',
      },
      {
        q: 'การลดขนาดหลังขาดทุนต่อเนื่องดีไหม',
        a: 'การลดขนาดชั่วคราวช่วยลดแรงกดดันระหว่างทบทวนแผน และทำให้พอร์ตมีพื้นที่ฟื้นตัวมากขึ้น',
        a2: 'วิธีที่ทำได้คือลดขนาดลงครึ่งหนึ่งหลังขาดทุน 3 ครั้งติด แล้วกลับไปขนาดเดิมเมื่อทำตามแผนได้ครบ 10 ไม้โดยไม่ผิดกติกา วิธีนี้ทำให้ยังอยู่ในตลาดและมีข้อมูลใหม่ให้วิเคราะห์ โดยไม่ทำให้พอร์ตทรุดเร็ว',
      },
    ],
    related: ['what-is-drawdown', 'recovery-after-loss', 'risk-per-trade'],
  },
  {
    slug: 'recovery-after-loss',
    category: 'การบริหารความเสี่ยง',
    categorySlug: 'risk-management',
    title: 'ทำไมการฟื้นตัวหลังขาดทุนจึงต้องใช้ผลตอบแทนที่สูงขึ้น',
    description:
      'อธิบายคณิตศาสตร์ของการฟื้นตัวหลัง Drawdown ว่าทำไมพอร์ตที่ลดลึกต้องใช้กำไรเปอร์เซ็นต์ที่มากขึ้น และผลต่อการวางแผนความเสี่ยง',
    readingTime: '6 นาที',
    updatedDate: '2026-10-13',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20account%20recovery%20concept%20teal%20shallow%20dip%20with%20a%20short%20climb%20and%20a%20deep%20dip%20with%20a%20long%20climb%20on%20light%20clean%20background%20editorial%20flat%20fintech%20design%20no%20text%20no%20people&width=1200&height=675&seq=art-recovery-after-loss-01&orientation=landscape',
    tags: ['Drawdown', 'ความเสี่ยง', 'ผลตอบแทน'],
    intro: [
      'เมื่อพอร์ตลดลง เปอร์เซ็นต์ที่ต้องทำได้เพื่อกลับมาเท่าทุนไม่เท่ากับเปอร์เซ็นต์ที่หายไป และช่องว่างนี้จะกว้างขึ้นเมื่อขาดทุนลึกขึ้น',
      'นี่คือเหตุผลทางคณิตศาสตร์ที่ทำให้การป้องกัน downside สำคัญกว่าการเร่งทำกำไร',
    ],
    sections: [
      {
        id: 'math',
        heading: 'ทำไมตัวเลขไม่สมมาตร',
        paragraphs: [
          'ถ้าพอร์ตลดจาก 100 เหลือ 90 ขาดทุน 10% แต่การกลับจาก 90 ไป 100 ต้องใช้กำไรประมาณ 11.1%',
          'ถ้าลดจาก 100 เหลือ 50 การกลับไป 100 ต้องใช้กำไรถึง 100% ยิ่งขาดทุนลึก ภาระในการฟื้นตัวยิ่งเพิ่มแบบไม่เป็นสัดส่วน',
        ],
        bullets: [
          'ขาดทุน 10% ต้องกำไรประมาณ 11% จึงเท่าทุน',
          'ขาดทุน 30% ต้องกำไรประมาณ 43% จึงเท่าทุน',
          'ขาดทุน 50% ต้องกำไร 100% จึงเท่าทุน',
        ],
        steps: [],
      },
      {
        id: 'pressure',
        heading: 'แรงกดดันที่ตามมา',
        paragraphs: [
          'เมื่อต้องทำกำไรสูงขึ้นเพื่อกลับมาเท่าทุน เทรดเดอร์มักเพิ่มความเสี่ยงหรือเทรดถี่ขึ้น ซึ่งทำให้โอกาสขาดทุนซ้ำสูงขึ้นอีก',
          'วงจรนี้คือสาเหตุที่ Drawdown เล็ก ๆ กลายเป็นปัญหาใหญ่ได้ หากไม่มีการกำหนดเพดานไว้ล่วงหน้า',
        ],
        bullets: [
          'อย่าเพิ่มความเสี่ยงเพื่อเร่งการฟื้นตัว',
          'ลดขนาดสถานะระหว่างทบทวนแผน',
          'โฟกัสการรักษาเงินทุนก่อนผลตอบแทน',
        ],
        steps: [],
      },
      {
        id: 'prevention',
        heading: 'ป้องกันดีกว่าฟื้นตัว',
        paragraphs: [
          'การจำกัดความเสี่ยงต่อออเดอร์และเพดานขาดทุนทำให้ Drawdown อยู่ในระดับที่ฟื้นได้ด้วยแผนเดิม',
          'มองการบริหารความเสี่ยงเป็นการลงทุนเพื่อรักษาความสามารถในการเทรดในระยะยาว ไม่ใช่ค่าใช้จ่ายที่ทำให้กำไรช้าลง',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Drawdown เท่าไรที่ยังฟื้นได้',
        a: 'ขึ้นอยู่กับแผนและความอดทนของแต่ละคน แต่ยิ่งตื้นยิ่งฟื้นง่าย จึงควรกำหนดเพดานที่ยอมรับได้ก่อนเริ่มเทรด',
        a2: 'ตัวเลขที่ควรรู้คือ ขาดทุน 20% ต้องทำกำไร 25% จึงจะกลับมาเท่าทุน ขาดทุน 50% ต้องทำ 100% ซึ่งแทบเป็นไปไม่ได้ในทางปฏิบัติ นี่คือเหตุผลที่เพดาน Drawdown ควรตั้งไว้ราว 10-15% แล้วหยุดทบทวนก่อนถึงจุดนั้น',
      },
      {
        q: 'หลังขาดทุนหนักควรทำอะไร',
        a: 'ลดขนาดสถานะ หยุดทบทวนผลและสาเหตุ แล้วกลับมาเทรดเมื่อมีแผนที่ชัดเจน ไม่ใช่เพื่อเอาคืน',
        a2: 'ลำดับที่ได้ผลคือ หยุดเทรดอย่างน้อย 1-3 วัน เปิด Statement ดูว่าไม้ที่ขาดทุนหนักที่สุด 3 ไม้ ผิดแผนข้อไหน แล้วลดขนาดสถานะลงครึ่งหนึ่งเมื่อกลับมา และเทรดด้วยขนาดนั้นอย่างน้อย 20 ไม้ก่อนพิจารณาเพิ่มคืน',
      },
    ],
    related: ['what-is-drawdown', 'consecutive-losses', 'increasing-size-after-loss'],
  },
  {
    slug: 'handling-trading-loss',
    category: 'การบริหารความเสี่ยง',
    categorySlug: 'risk-management',
    title: 'วิธีรับมือเมื่อการเทรดขาดทุน',
    description:
      'ขั้นตอนรับมือหลังขาดทุนอย่างเป็นระบบ ตั้งแต่หยุดตรวจสอบ ไปจนถึงการกลับมาเทรดด้วยขนาดที่เหมาะสม',
    readingTime: '6 นาที',
    updatedDate: '2026-10-12',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20calm%20after%20trading%20loss%20concept%20teal%20notebook%20and%20warm%20orange%20pencil%20on%20light%20clean%20background%20editorial%20flat%20fintech%20design%20no%20text%20no%20people&width=1200&height=675&seq=art-handling-loss-01&orientation=landscape',
    tags: ['วินัย', 'จิตวิทยา', 'ความเสี่ยง'],
    intro: [
      'การขาดทุนเป็นส่วนหนึ่งของต้นทุนการเทรด สิ่งที่แยกเทรดเดอร์ที่ไปต่อได้กับคนที่หยุดคือวิธีจัดการหลังขาดทุน',
      'เป้าหมายไม่ใช่การลืมการขาดทุน แต่คือการดึงข้อมูลจากมันโดยไม่ทำร้ายพอร์ตเพิ่ม',
    ],
    sections: [
      {
        id: 'pause',
        heading: 'หยุดก่อน อย่าตอบโต้ทันที',
        paragraphs: [
          'หลังขาดทุน ความอยากเอาคืนจะสูงที่สุด การปิดแพลตฟอร์มชั่วครู่และกลับมาดูข้อมูลด้วยความสงบช่วยลดโอกาสตัดสินใจผิด',
          'ถ้าเข้าใกล้เพดานขาดทุนที่ตั้งไว้ ให้หยุดเทรดสำหรับวันนั้นทันทีตามแผน',
        ],
        bullets: [
          'หยุดเทรดเมื่อถึงเพดานที่กำหนด',
          'อย่าเปิดออเดอร์ใหม่ทันทีเพื่อเอาคืน',
          'กลับมาดูข้อมูลเมื่ออารมณ์นิ่งแล้ว',
        ],
        steps: [],
      },
      {
        id: 'review',
        heading: 'ทบทวนว่าอะไรอยู่นอกแผน',
        paragraphs: [
          'แยกให้ออกว่าการขาดทุนครั้งนี้เป็นส่วนหนึ่งของความน่าจะเป็น หรือเกิดจากการทำผิดแผน เช่น เข้าเร็วเกินไป ขนาดใหญ่เกินไป หรือเลื่อน Stop Loss',
          'ถ้าทำตามแผนครบแล้ว ผลลัพธ์ที่ขาดทุนยังถือว่าถูกต้องในเชิงกระบวนการ และไม่ควรเปลี่ยนระบบทันที',
        ],
        bullets: [
          'เช็กว่าขนาดสถานะเป็นไปตามแผนหรือไม่',
          'เช็กว่าจุดเข้าและ Stop Loss มีเหตุผลรองรับ',
          'แยกผลลัพธ์ออกจากคุณภาพของการตัดสินใจ',
        ],
        steps: [],
      },
      {
        id: 'return',
        heading: 'กลับมาเทรดอย่างมีกรอบ',
        paragraphs: [
          'กลับมาด้วยขนาดสถานะเดิมหรือเล็กลงก่อน จนกว่าจะมั่นใจว่ากระบวนการยังทำงานได้ตามปกติ',
          'การกลับมาช้าเล็กน้อยไม่ทำให้เสียโอกาสอะไรมาก แต่การกลับมาเร็วเกินไปด้วยความเสี่ยงที่เพิ่มขึ้นอาจทำให้เสียมากกว่าที่คิด',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'ขาดทุนแล้วควรพักนานแค่ไหน',
        a: 'ไม่มีเวลาตายตัว ขึ้นอยู่กับว่าเมื่อไรคุณกลับมาทบทวนข้อมูลได้อย่างเป็นกลางและมีแผนชัดเจนอีกครั้ง',
        a2: 'เกณฑ์ที่วัดได้คือ กลับมาเมื่อตอบได้ว่าขาดทุนเพราะอะไร และแก้ด้วยกฎอะไรในแผน ถ้าตอบไม่ได้แปลว่ายังไม่พร้อม ระยะที่พบบ่อยคือ 2-5 วันสำหรับการขาดทุนปกติ และ 2-4 สัปดาห์หากพอร์ตเสียหายเกิน 10%',
      },
      {
        q: 'ควรเปลี่ยนระบบหลังขาดทุนไหม',
        a: 'ควรดูว่าขาดทุนเพราะระบบหรือเพราะทำผิดแผน ถ้าทำตามแผนครบ ควรสะสมข้อมูลให้มากพอก่อนสรุป',
        a2: 'เกณฑ์คือต้องมีอย่างน้อย 30-50 ไม้ที่ทำตามแผนครบก่อนจึงสรุปได้ ถ้าทำผิดแผนเกิน 30% ของไม้ ปัญหาอยู่ที่วินัยไม่ใช่ระบบ และการเปลี่ยนระบบตอนนี้จะทำให้ข้อมูลที่สะสมมาใช้ไม่ได้',
      },
    ],
    related: ['revenge-trading', 'consecutive-losses', 'forex-trading-psychology'],
  },
  {
    slug: 'revenge-trading',
    category: 'การบริหารความเสี่ยง',
    categorySlug: 'risk-management',
    title: 'ทำไมการแก้แค้นตลาดจึงเพิ่มความเสี่ยง',
    description:
      'อธิบายวงจร Revenge Trading ที่ทำให้ขาดทุนลุกลาม พร้อมสัญญาณเตือนและวิธีตัดวงจรก่อนเสียหายหนัก',
    readingTime: '6 นาที',
    updatedDate: '2026-10-11',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20revenge%20trading%20cycle%20concept%20circular%20teal%20arrows%20with%20warm%20orange%20warning%20center%20on%20light%20clean%20background%20editorial%20flat%20fintech%20design%20no%20text%20no%20people&width=1200&height=675&seq=art-revenge-trading-01&orientation=landscape',
    tags: ['จิตวิทยา', 'วินัย', 'ความเสี่ยง'],
    intro: [
      'Revenge Trading คือการกลับเข้าเทรดทันทีหลังขาดทุนเพื่อเอาคืน ด้วยความโกรธหรือต้องการพิสูจน์ว่าตัวเองไม่ได้ผิด',
      'ปัญหาไม่ได้อยู่ที่การเทรดครั้งถัดไป แต่อยู่ที่มันมักเกิดขึ้นโดยไม่มีแผนและด้วยขนาดที่ใหญ่ขึ้น',
    ],
    sections: [
      {
        id: 'cycle',
        heading: 'วงจรที่ทำให้ขาดทุนลุกลาม',
        paragraphs: [
          'ขาดทุน → อยากเอาคืน → เปิดออเดอร์เร็วและใหญ่ขึ้น → ขาดทุนอีก → เพิ่มความเสี่ยงอีก เพื่อให้กลับมาเท่าทุน',
          'ทุกครั้งที่วนซ้ำ ความเสี่ยงต่อออเดอร์จะไม่คงที่ และเพดานขาดทุนที่เคยตั้งไว้จะถูกละเลย',
        ],
        bullets: [
          'เข้าออเดอร์โดยไม่มีแผนรองรับ',
          'ขนาดสถานะใหญ่ขึ้นเรื่อย ๆ',
          'เพดานขาดทุนถูกมองข้าม',
        ],
        steps: [],
      },
      {
        id: 'signs',
        heading: 'สัญญาณเตือนที่สังเกตได้',
        paragraphs: [
          'ถ้าคุณเริ่มเปิดกราฟถี่ขึ้นหลังขาดทุน รู้สึกว่าต้องเทรดให้ได้กำไรก่อนปิดวัน หรือรู้สึกโกรธตลาด นั่นคือสัญญาณว่าควรหยุด',
          'การจดบันทึกอารมณ์คู่กับผลการเทรดจะช่วยให้เห็นรูปแบบนี้ได้ชัดขึ้นก่อนมันกลายเป็นความเสียหายก้อนใหญ่',
        ],
        bullets: [
          'เทรดถี่ขึ้นหลังขาดทุน',
          'รู้สึกต้องเอาคืนก่อนจบวัน',
          'ตัดสินใจจากอารมณ์มากกว่าข้อมูล',
        ],
        steps: [],
      },
      {
        id: 'break',
        heading: 'ตัดวงจรอย่างไร',
        paragraphs: [
          'กำหนดกติกาชัดเจน เช่น หยุดเทรดทันทีเมื่อขาดทุนครบจำนวนที่กำหนดในหนึ่งวัน และไม่เปิดออเดอร์ใหม่ภายในเวลาที่กำหนดหลังขาดทุนหนัก',
          'ยิ่งกติกาชัดและวัดผลได้ ยิ่งลดช่องว่างให้อารมณ์เข้ามาตัดสินใจ',
        ],
        bullets: [
          'กำหนดจำนวนขาดทุนสูงสุดต่อวัน',
          'พักหลังขาดทุนตามเวลาที่กำหนด',
          'กลับมาเมื่อมีแผนและขนาดที่เหมาะสม',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Revenge Trading ต่างจากเทรดปกติอย่างไร',
        a: 'ต่างที่ไม่มีแผนรองรับและมักเพิ่มขนาดเพื่อเอาคืน ผลลัพธ์จึงขึ้นอยู่กับอารมณ์มากกว่ากระบวนการ',
        a2: 'สัญญาณที่สังเกตได้คือ เปิดไม้ภายใน 5-10 นาทีหลังขาดทุน เพิ่มขนาดเป็น 2 เท่าขึ้นไป และไม่มีจุด Stop Loss ที่คำนวณมาก่อน หากเกิดครบสามข้อนี้ ควรปิดแพลตฟอร์มทันทีอย่างน้อย 1 ชั่วโมง',
      },
      {
        q: 'หยุดแล้วโอกาสจะหายไปไหม',
        a: 'ตลาดเปิดใหม่ทุกวัน การหยุดเพื่อรักษาเงินทุนและสมาธิคุ้มกว่าการฝืนเทรดด้วยอารมณ์ที่ไม่นิ่ง',
        a2: 'การฝืนเทรดตอนอารมณ์ไม่นิ่งมักทำให้ขาดทุนเพิ่ม 2-3 เท่าของไม้ปกติ เพราะตัดสินใจเร็วและเพิ่มขนาด ลองนับดูว่ากำไรที่ได้จากการเทรดตอนหงุดหงิดมีสักกี่ไม้ เทียบกับไม้ที่ขาดทุนในช่วงเดียวกัน',
      },
    ],
    related: ['handling-trading-loss', 'increasing-size-after-loss', 'forex-trading-psychology'],
  },
  {
    slug: 'increasing-size-after-loss',
    category: 'การบริหารความเสี่ยง',
    categorySlug: 'risk-management',
    title: 'การเพิ่มขนาดการซื้อขายเพื่อเอาคืนมีความเสี่ยงอย่างไร',
    description:
      'อธิบายผลของการเพิ่มขนาดสถานะหลังขาดทุน ว่าทำไมมันทำให้ความเสี่ยงไม่คงที่ และทางเลือกที่ปลอดภัยกว่าคืออะไร',
    readingTime: '6 นาที',
    updatedDate: '2026-10-10',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20martingale%20risk%20concept%20teal%20bars%20growing%20taller%20with%20warm%20orange%20warning%20triangle%20on%20light%20clean%20background%20editorial%20flat%20fintech%20design%20no%20text%20no%20people&width=1200&height=675&seq=art-increasing-size-01&orientation=landscape',
    tags: ['Position Sizing', 'ความเสี่ยง', 'วินัย'],
    intro: [
      'การเพิ่มขนาดหลังขาดทุนดูเหมือนเป็นวิธีเร่งให้กลับมาเท่าทุน แต่ในความเป็นจริงมันเปลี่ยนความเสี่ยงของแต่ละออเดอร์ให้มากขึ้นเรื่อย ๆ',
      'เมื่อความเสี่ยงไม่คงที่ ผลลัพธ์ระยะยาวก็คาดเดาไม่ได้ และพอร์ตอาจเสียหายเกินกว่าที่วางแผนไว้ในไม่กี่ออเดอร์',
    ],
    sections: [
      {
        id: 'math',
        heading: 'ทำไมมันไม่สมดุล',
        paragraphs: [
          'ถ้าเพิ่มขนาดเป็นสองเท่าหลังขาดทุนทุกครั้ง ความเสี่ยงต่อออเดอร์จะโตแบบทวีคูณ และการขาดทุนต่อเนื่องเพียงไม่กี่ครั้งก็อาจกินเงินทุนทั้งหมด',
          'การขาดทุน 1% สองครั้งไม่ได้ต้องการการเสี่ยง 4% เพื่อชดเชย แต่ต้องใช้กำไรที่มากขึ้นจากฐานที่เล็กลง',
        ],
        bullets: [
          'ความเสี่ยงต่อออเดอร์ไม่คงที่',
          'ขาดทุนต่อเนื่องกลายเป็นหายนะได้เร็ว',
          'การชดเชยต้องใช้กำไรที่สูงกว่าที่คิด',
        ],
        steps: [],
      },
      {
        id: 'psychology',
        heading: 'แรงผลักดันเบื้องหลัง',
        paragraphs: [
          'การเพิ่มขนาดมักมาจากความรู้สึกว่าต้องพิสูจน์ว่าตัวเองถูก หรือกลัวว่าจะเสียโอกาสในการเอาคืน',
          'การแยกความรู้สึกเหล่านี้ออกจากแผนด้วยกติกาที่เขียนไว้ล่วงหน้าจะช่วยให้ตัดสินใจได้เป็นกลางกว่า',
        ],
        bullets: [
          'อย่าให้ความรู้สึกกำหนดขนาดสถานะ',
          'ใช้กติกาที่เขียนไว้ก่อนเทรด',
          'ยอมรับว่าการขาดทุนเป็นส่วนหนึ่งของกระบวนการ',
        ],
        steps: [],
      },
      {
        id: 'alternative',
        heading: 'ทางเลือกที่ปลอดภัยกว่า',
        paragraphs: [
          'คงความเสี่ยงต่อออเดอร์ให้เท่าเดิมหรือลดลงชั่วคราวหลังขาดทุนต่อเนื่อง แล้วใช้การทบทวนแผนแทนการเร่งความเสี่ยง',
          'ถ้าต้องการฟื้นพอร์ตเร็วจริง ๆ สิ่งที่ทำได้คือเพิ่มคุณภาพของออเดอร์ ไม่ใช่เพิ่มขนาด',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'เพิ่มขนาดหลังชนะได้ไหม',
        a: 'ทำได้ตามแผน เช่น การขยับขนาดตามพอร์ตที่โตขึ้น แต่ไม่ควรเพิ่มเพราะอารมณ์หรือเพราะเพิ่งชนะติดกัน',
        a2: 'วิธีที่ปลอดภัยคือเพิ่มขนาดตามพอร์ต เช่น พอร์ตโต 20% จึงเพิ่ม Lot 20% และเพิ่มได้ไม่เกินหนึ่งครั้งต่อไตรมาส วิธีนี้ผูกขนาดกับเงินทุนจริง ไม่ใช่กับอารมณ์จากไม้ที่เพิ่งชนะ',
      },
      {
        q: 'หลังขาดทุนควรลดขนาดไหม',
        a: 'การลดขนาดชั่วคราวเป็นวิธีที่ช่วยให้พอร์ตมีพื้นที่ทบทวนและลดแรงกดดันระหว่างฟื้นตัว',
        a2: 'ตัวเลขที่ใช้ได้คือลดขนาดลงครึ่งหนึ่งเมื่อพอร์ตลดลง 5% จากจุดสูงสุด และกลับไปขนาดเดิมเมื่อพอร์ตทำจุดสูงใหม่ได้ วิธีนี้ทำให้ช่วงขาดทุนกินทุนช้าลงราวครึ่งหนึ่งโดยไม่ต้องหยุดเทรด',
      },
    ],
    related: ['revenge-trading', 'risk-per-trade', 'recovery-after-loss'],
  },
];